const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const isoWeek = require('dayjs/plugin/isoWeek');
// 引入中文语言包
const zhCn = require('dayjs/locale/zh-cn');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
// 设置语言为中文
dayjs.locale('zh-cn');
// 设置默认北京时区
dayjs.tz.setDefault('Asia/Shanghai');

export default dayjs;



// WEBPACK FOOTER //
// ./src/utils/day.js